class AsSeenOnSlider extends HTMLElement {
  constructor() {
    super();
    this.sliderImage = null
  }

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    const swiper = new Swiper(this.querySelector('.swiper'), {
      slidesPerView: 1.3,
      spaceBetween: 8,
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
      },
      breakpoints: {
        0: {
          slidesPerView: 1.3,
          spaceBetween: 8,
        },
        600: {
          slidesPerView: 2,
          spaceBetween: 16
        },
        900: {
          slidesPerView: 4,
          spaceBetween: 16
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 16
        }
      },
    });
  }
}

customElements.define('as-seen-on-slider', AsSeenOnSlider);
